import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { MarketDepthData } from './types';
import type { TabType } from '../../components/P2p/OrderForm/types';

/* eslint-disable no-param-reassign */

export type OrderBookPrices = {
  price?: string | number;
  averagePrice?: string | number;
  amount?: string | number;
  index?: string | number;
  total?: string | number;
  active?: boolean;
};

export interface P2pActionInitialValuesTypes {
  orderFormType: TabType;
  isQuoteQty: {
    sell: boolean;
    buy: boolean;
  };
  orderBook: {
    sellOrder: OrderBookPrices;
    buyOrder: OrderBookPrices;
    depthData?: MarketDepthData | null;
  };
}

const initialState: P2pActionInitialValuesTypes = {
  orderFormType: 'limit',
  isQuoteQty: {
    sell: false,
    buy: false
  },
  orderBook: {
    sellOrder: {
      price: '',
      averagePrice: '',
      amount: '',
      total: '',
      active: false
    },
    buyOrder: {
      price: '',
      averagePrice: '',
      amount: '',
      total: '',
      active: false
    },
    depthData: null
  }
};

const p2p = createSlice({
  name: 'p2p',
  initialState,
  reducers: {
    setOrderFormType: (
      state: P2pActionInitialValuesTypes,
      action: PayloadAction<TabType>
    ) => {
      state.orderFormType = action.payload;
    },
    setBuyOrderInformation: (
      state: P2pActionInitialValuesTypes,
      action: PayloadAction<OrderBookPrices>
    ) => {
      state.orderBook.buyOrder = action.payload;
      state.orderBook.buyOrder.active = true;
      state.orderBook.sellOrder.active = false;
    },
    setAveragePrice: (
      state: P2pActionInitialValuesTypes,
      action: PayloadAction<OrderBookPrices>
    ) => {
      state.orderBook.buyOrder = action.payload;
      state.orderBook.sellOrder = action.payload;
    },
    setSellOrderInformation: (
      state: P2pActionInitialValuesTypes,
      action: PayloadAction<OrderBookPrices>
    ) => {
      state.orderBook.sellOrder = action.payload;
      state.orderBook.sellOrder.active = true;
      state.orderBook.buyOrder.active = false;
    },
    setOrderBookData: (
      state: P2pActionInitialValuesTypes,
      action: PayloadAction<MarketDepthData>
    ) => {
      state.orderBook.depthData = action.payload;
    },
    clearOrderBookData: (state: P2pActionInitialValuesTypes) => {
      state.orderBook.depthData = null;
      state.orderBook.buyOrder = { ...initialState.orderBook.buyOrder };
      state.orderBook.sellOrder = { ...initialState.orderBook.sellOrder };
    },
    setIsQuoteQty: (
      state: P2pActionInitialValuesTypes,
      action: PayloadAction<{ side: 'buy' | 'sell'; value: boolean }>
    ) => {
      state.isQuoteQty[action.payload.side] = action.payload.value;
    }
  }
});

// Action creators are generated for each case reducer function
export const {
  setAveragePrice,
  setOrderFormType,
  setIsQuoteQty,
  setBuyOrderInformation,
  setSellOrderInformation,
  setOrderBookData,
  clearOrderBookData
} = p2p.actions;

export default p2p.reducer;
